import DOMPurify from "dompurify";

export default function replaceLineBreaks(str: string): string {
  return DOMPurify.sanitize(str.replace(/\n/g, "<br />"));
}
